import axios from 'axios'

export default class googlePlacesApi {
  /**
    * @desc returns best guess for the user's current latitude and longitude
    * @return object - Ex: { lat: 44.9620913, lng: -93.2896248 }
  */
  static async getLatLong () {
    var request = {
      method: 'post',
      url: 'https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBaeLmrQzAq8oZRiLHpY_6OW3hk0tlEzdM',
      data: { considerIp: 'true' }
    }
    var response = await axios(request)
    return response.data.location
  }

  /**
    * @desc returns object containing address components
    * @param number latitude
    * @param number longitude
    * @return object - example below
        0: Object { long_name: "2012", short_name: "2012", types: (1) […] }
        1: Object { long_name: "Aldrich Avenue South", short_name: "Aldrich Ave S", types: (1) […] }
        2: Object { long_name: "Lowry Hill East", short_name: "Lowry Hill East", types: (2) […] }
        3: Object { long_name: "Minneapolis", short_name: "Minneapolis", types: (2) […] }
        4: Object { long_name: "Hennepin County", short_name: "Hennepin County", types: (2) […] }
        5: Object { long_name: "Minnesota", short_name: "MN", types: (2) […] }
        6: Object { long_name: "United States", short_name: "US", types: (2) […] }
        7: Object { long_name: "55405", short_name: "55405", types: (1) […] }
  */
  static async geocode (latitude, longitude) {
    var request = {
      method: 'post',
      url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
           latitude + ',' + longitude +
           '&key=AIzaSyBaeLmrQzAq8oZRiLHpY_6OW3hk0tlEzdM'
    }
    var results = await axios(request)
    var addressComponents = results.data.results[0].address_components
    return addressComponents
  }

  static async getCityState () {
    var latlng = await this.getLatLong()
    var addressComponents = await this.geocode(latlng.lat, latlng.lng)
    var cityState = {}
    for (var component in addressComponents) {
      var types = addressComponents[component].types
      if (types.indexOf('locality') > -1) cityState.city = addressComponents[component].long_name
      if (types.indexOf('administrative_area_level_1') > -1) cityState.state = addressComponents[component].long_name
    }
    return cityState
  }

  /**
    * @desc turns a zip code into a lat long object
    * @param number zipCode - Ex: 55405
    * @return object - Ex: { lat: 44.9620913, lng: -93.2896248 }
  */
  static async zipToLatLong (area) {
    area = area.replace(' ', '+')
    var request = {
      method: 'post',
      url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' +
           area +
           '&key=AIzaSyBaeLmrQzAq8oZRiLHpY_6OW3hk0tlEzdM'
    }
    var results = await axios(request)
    return results.data.results.length > 0 ? results.data.results[0].geometry.location : null
  }

  /**
    * @desc turns output from geocode into a zip code
    * @param object addressComponents - the address components to search
    * @return number - Ex: 55405
  */
  static unpackPostalCode (addressComponents) {
    for (var component of addressComponents) {
      if (component.types.includes('postal_code')) {
        return component.long_name
      }
    }
  }

  /**
    * @desc returns best guess for the zip code the user is currently in
    * @return number - Ex: 55405
  */
  static async getUsersBestGuessPostalCode () {
    var latLong = await this.getLatLong()
    var address = await this.geocode(latLong.lat, latLong.lng)
    var postalCode = await this.unpackPostalCode(address)
    return postalCode
  }

  /**
  */
  static async googleSearch (node, queryString, area) {
    var that = this
    var latlong = await this.zipToLatLong(area)
    if (!latlong) return
    return new Promise((resolve, reject) => {
      var request = {
        query: queryString,
        radius: '10000',
        location: latlong
      }
      var service = new window.google.maps.places.PlacesService(node)
      service.textSearch(request, (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          return resolve(results)
        } else if (status === window.google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
          setTimeout(() => {
            return resolve(that.googleSearch(node, queryString, area))
          }, 1000)
        } else {
          return reject(status)
        }
      })
    })
  }

  static async googleSearchLatLong (node, queryString, latlong) {
    var that = this
    return new Promise((resolve, reject) => {
      var request = {
        query: queryString,
        radius: '1000',
        location: latlong
      }
      var service = new window.google.maps.places.PlacesService(node)
      service.textSearch(request, (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          return resolve(results)
        } else if (status === window.google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
          setTimeout(() => {
            return resolve(that.googleSearch(node, queryString, latlong))
          }, 1000)
        } else {
          return reject(status)
        }
      })
    })
  }

  static async marketGoogleSearchResults (node, queryString, area) {
    try {
      var searchResults = await this.googleSearch(node, queryString, area)
      var returnArray = []
      for (var index in searchResults) {
        var result = {
          title: searchResults[index].name,
          businessId: searchResults[index].place_id,
          rating: searchResults[index].rating,
          google: true
          // id: searchResults[index].id
        }
        returnArray.push(result)
      }
      return returnArray
    } catch (error) {
      console.log(error)
    }
  }

  static googleDetails (node, placeId) {
    var that = this
    return new Promise((resolve, reject) => {
      var request = {
        placeId: placeId,
        fields:
          [
            'photos',
            'international_phone_number',
            'website',
            'address_components',
            'name',
            'opening_hours',
            'reviews',
            'formatted_address',
            'rating'
          ]
      }
      var service = new window.google.maps.places.PlacesService(node)
      service.getDetails(request, (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          return resolve(results)
        } else if (status === window.google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
          setTimeout(() => {
            return resolve(that.googleDetails(node, placeId))
          }, 1000)
        } else {
          return reject(status)
        }
      })
    })
  }

  static async getDefaultLocation () {
    var cityState = await this.getCityState()
    var loc = ''
    if (cityState.city) {
      loc = cityState.city
    } else if (cityState.state) {
      loc = cityState.state
    } else if (cityState.city && cityState.state) {
      loc = cityState.city + ', ' + cityState.state
    }
    return loc
  }
}



// WEBPACK FOOTER //
// ./src/lib/googlePlacesApi.js